import React from 'react';
import './apps.scss';
import { Toggle } from '../../shared/toggle/toggle';
import { useStores } from '../../store';
import usePromiseFeedback from '../../shared/promise-feedback/usePromiseFeedback';
import useCustomModal from '../../shared/custom-modal/custom-modal';
import { ActionType, ApplicationsDefaultBehavior } from 'src/utils/enums';
import managedAppsService from '../../../services/managed-apps.service';

const DefaultBehaviorModalBody = () => <div>Managed apps will remain unchanged in the list below.</div>;

export const DefaultBehavior = () => {
    const { fwVersionStore, ruleStore } = useStores();
    const [showModal, , contextHolder] = useCustomModal();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();

    const setDefaultBehaviorModal = (isAllow: boolean, direction: string, action: ActionType) => {
        showModal({
            wrapClassName: 'set-default-behavior',
            width: 618,
            title: `Set ${direction} default behavior to ${action}?`,
            body: DefaultBehaviorModalBody,
            okText: `${action} ${direction}`,
            cancelText: 'Cancel',
            onOk: () => promiseFeedbackFactory({
                promise: fwVersionStore.genericCrudMethod(managedAppsService.changeAppsDefaultBehavior,
                    [isAllow ? ApplicationsDefaultBehavior.ALLOW_ALL : ApplicationsDefaultBehavior.BLOCK_ALL, direction]), 
                notifObj: {show: false}
            }),
            closable: true
        });
    };

    return <div className="default-behavior-wrapper">
        <div className="title">
            Default behavior for all app traffic except those explicitly managed below
        </div>
        <div className={`outbound-inactive-${false} inbound-inactive-${false} toggle-buttons`}>
            <Toggle value={ruleStore.isAppsInboundAllowAll} disableReason={fwVersionStore.getDisableReason}
                onChange={(isAllow: boolean) => setDefaultBehaviorModal(isAllow, 'inbound', ruleStore.isAppsInboundAllowAll ? ActionType.BLOCK : ActionType.ALLOW)}
                withIcon={true} />

            <Toggle value={ruleStore.isAppsOutboundAllowAll} disableReason={fwVersionStore.getDisableReason}
                    onChange={(isBlock: boolean) => setDefaultBehaviorModal(isBlock, 'outbound', ruleStore.isAppsOutboundAllowAll ? ActionType.BLOCK : ActionType.ALLOW )}
                    withIcon={true}/>
        </div>
        {contextHolder}
        {promiseContextHolder}
    </div>;
};